<!--
 * @Author: nsj
 * @Date: 2021-03-03 15:06:16
 * @Description: description
-->
<template>
  <div class="caseDetail">
    <div class="header">
      <Tabs :animated="false" v-model="tabName" @on-click="browseNotice">
        <TabPane label="总览信息" tab="tab" name="1">
          <div class="content">
            <div class="left">
              <div class="baseInfo">
                <h2>个人信息</h2>
                <div class="box">
                  <div style="margin-bottom: 6px">
                    患者姓名<i style="color: red">*</i>
                  </div>
                  <Input
                    v-model="patientName"
                    :disabled="IsDisabled"
                    style="width: 400px"
                  />
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">
                    患者性别<i style="color: red">*</i>
                  </div>
                  <RadioGroup v-model="sex" style="width: 400px">
                    <Radio
                      label="男"
                      :disabled="IsDisabled"
                      style="margin-right: 64px"
                    ></Radio>
                    <Radio :disabled="IsDisabled" label="女"></Radio>
                  </RadioGroup>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">
                    患者年龄<i style="color: red">*</i>
                  </div>
                  <InputNumber
                    :min="1"
                    :precision="0"
                    :disabled="IsDisabled"
                    style="width: 400px"
                    v-model="patientAge"
                  ></InputNumber>
                  <!-- <Input
                    v-model="patientAge"
                    :disabled="IsDisabled"
                    style="width: 400px"
                  /> -->
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">身高</div>
                  <Input
                    type="number"
                    v-model="stature"
                    :disabled="IsDisabled"
                    style="width: 400px"
                  >
                    <span slot="append">cm</span>
                  </Input>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">体重</div>
                  <Input
                    type="number"
                    v-model="weight"
                    :disabled="IsDisabled"
                    style="width: 400px"
                  >
                    <span slot="append">kg</span>
                  </Input>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">民族</div>
                  <Select
                    v-model="nation"
                    :disabled="IsDisabled"
                    style="width: 400px"
                    slot="append"
                  >
                    <Option value="汉族">汉族</Option>
                    <Option value="壮族">壮族</Option>
                    <Option value="回族">回族</Option>
                    <Option value="满族">满族</Option>
                    <Option value="蒙古族">蒙古族</Option>
                    <Option value="其他">其他</Option>
                  </Select>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">职业</div>
                  <Select
                    v-model="occupation"
                    :disabled="IsDisabled"
                    :transfer="true"
                    style="width: 400px"
                  >
                    <Option
                      v-for="item in occupationArr"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.label }}</Option
                    >
                  </Select>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">婚姻状况</div>
                  <Select
                    v-model="maritalStatus"
                    style="width: 400px"
                    :transfer="true"
                    :disabled="IsDisabled"
                  >
                    <Option value="未婚">未婚</Option>
                    <Option value="已婚">已婚</Option>
                    <Option value="其他">其他</Option>
                  </Select>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">检查系统</div>
                  <Select
                    :disabled="IsDisabled"
                    v-model="auditingSystem"
                    style="width: 400px"
                    :transfer="true"
                  >
                    <Option
                      v-for="item in systemName"
                      :value="item.value"
                      :key="item.value"
                      >{{ item.label }}</Option
                    >
                  </Select>
                </div>
                <div class="box">
                  <div style="margin-bottom: 6px">
                    主诉<i style="color: red">*</i>
                  </div>
                  <Input
                    :disabled="IsDisabled"
                    v-model="action"
                    type="textarea"
                    :rows="4"
                    style="width: 400px"
                  />
                </div>
                <div
                  v-if="sendPeopleJid == stroge.UserJid"
                  class="box btnBottom"
                >
                  <Button type="primary" @click="Disabled">{{
                    IsDisabled ? "编辑" : "取消编辑"
                  }}</Button>
                  <Button type="primary" @click="savePerInfo" v-if="!IsDisabled"
                    >保存</Button
                  >
                </div>
              </div>
            </div>
            <div class="right">
              <div class="operation">
                <h2>操作历史</h2>
                <List class="trends">
                  <ListItem v-for="(item, index) in operationInfo" :key="index">
                    <div class="doctorInfo">
                      <div class="face">
                        <img
                          :src="
                            item.OImg
                              ? item.OImg
                              : require('../assets/other.png')
                          "
                          alt=""
                          style="width: 50px; height: 50px; border-radius: 50%"
                        />
                      </div>
                      <div class="introduce">
                        <p class="greet" v-html="item.OperationHis"></p>
                        <p class="time">
                          {{
                            item.CrtDate ? item.CrtDate.replace("T", " ") : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </ListItem>
                </List>
                <div class="hint" v-if="operationInfo.length == 0">
                  暂无操作历史
                </div>
              </div>
              <div class="doctor">
                <div class="docHead">
                  <h2>参与医生</h2>
                  <!--  -->
                  <Button
                    type="primary"
                    v-if="stroge.Level ? stroge.Level == 'A' : false"
                    icon="md-add"
                    @click="selectDoc = true"
                    >邀请医生</Button
                  >
                  <Modal
                    class="modalmod"
                    v-model="selectDoc"
                    title="选择医生"
                    @on-ok="inviteDoctor"
                    @on-cancel="cancel"
                  >
                    <Row class="modalmain">
                      <Col span="12">
                        <Input
                          search
                          enter-button="检索"
                          v-model="searchvalue"
                          placeholder="请输入医生姓名检索"
                          @on-search="searchDoctor"
                        />
                        <div class="doctorlist">
                          <div
                            style="
                              border-bottom: 1px solid #e9e9e9;
                              margin-bottom: 6px;
                            "
                          >
                            <Checkbox
                              :indeterminate="indeterminate"
                              :value="checkAll"
                              @click.prevent.native="handleCheckAll"
                              >全选</Checkbox
                            >
                          </div>
                          <CheckboxGroup
                            v-model="checkdoctor"
                            @on-change="checkdoctorChange"
                          >
                            <Checkbox
                              v-for="(item, index) in doctorList"
                              :key="index"
                              :label="item.UserJid"
                              :disabled="item.IsChoose == 'T'"
                            >
                              <img :src="item.Img" style="margin-right: 5px" />
                              <span>{{ item.DocName }}</span>
                            </Checkbox>
                          </CheckboxGroup>
                        </div>
                      </Col>
                      <Col span="12">
                        <div class="">
                          <Tag
                            v-for="(item, index) in doctorShow"
                            :key="index"
                            :name="item.DocName"
                            closable
                            @on-close="handlemodalClose(index)"
                            >{{ item.DocName }}</Tag
                          >
                        </div>
                      </Col>
                    </Row>
                  </Modal>
                </div>
                <div
                  class="docCard"
                  @click="DoctorDetail(item)"
                  v-for="(item, index) in joinDoctor"
                  :key="index"
                >
                  <img
                    :src="
                      item.ImgUrl ? item.ImgUrl : require('../assets/other.png')
                    "
                    alt=""
                    style="width: 50px; height: 50px; border-radius: 50%"
                  />
                  <div class="docContent">
                    <div class="box1">
                      <span>{{ item.DocName }}</span>
                      <span>{{ item.DocPosition }}</span>
                      <span
                        :class="{
                          biaoqian: item.IsFirst == 'T',
                          biaoqian1: item.IsFirst == 'Y',
                        }"
                        >{{
                          item.IsFirst == "Y"
                            ? "发起人"
                            : item.IsFirst == "T"
                            ? "首诊"
                            : ""
                        }}</span
                      >
                    </div>
                    <div class="box2">
                      <span>{{ item.CenterName }}</span>
                      <!-- <span>{{ item.DepartmentName }}</span> (赵越提科室名字太长导致换行，耿晓晨提议隐藏科室) -->
                    </div>
                  </div>
                </div>
              </div>
              <Modal
                class-name="doctorDetail"
                v-model="doctorDetail"
                footer-hide
                width="420"
                @on-cancel="cancel"
              >
                <div class="mod">
                  <img class="img1" :src="partDoctorInfo.DocImg" alt="" />
                  <div>
                    <span>{{ partDoctorInfo.DocName }}</span>
                    <span>{{ partDoctorInfo.DocPosition }}</span>
                  </div>
                  <div>
                    <span>{{ partDoctorInfo.HospitalName }}</span>
                    <span>{{ partDoctorInfo.DepartmentName }}</span>
                  </div>
                  <div style="border-bottom: 1px dashed #c1c1c1">
                    <span style="margin-right: 5px"
                      ><Icon type="ios-pin-outline"
                    /></span>
                    <span>{{ partDoctorInfo.Position }}</span>
                  </div>
                  <div>
                    <p>简介：</p>
                    <div
                      style="
                        width: 300px;
                        height: 100px;
                        border: 1px solid #c1c1c1;
                      "
                    >
                      {{ partDoctorInfo.Intro }}
                    </div>
                  </div>
                  <div>
                    <p>擅长：</p>
                    <div
                      style="
                        width: 300px;
                        height: 100px;
                        border: 1px solid #c1c1c1;
                      "
                    >
                      {{ partDoctorInfo.GoodAt }}
                    </div>
                  </div>
                  <div @click="expert" style="cursor: pointer" class="BotTeam">
                    <img
                      src="../assets/img1.png"
                      alt=""
                      style="width: 30px; height: 30px"
                    />
                    <span>{{ partDoctorInfo.TeamName }}</span>
                    <img
                      src="../assets/img2.jpg"
                      alt=""
                      style="width: 30px; height: 30px"
                    />
                  </div>
                </div>
              </Modal>
            </div>
          </div>
        </TabPane>
        <TabPane label="病史" tab="tab" name="2">
          <Spin size="large" fix v-if="loading">
            <Icon
              type="ios-loading"
              size="18"
              class="demo-spin-icon-load"
            ></Icon>
            <div>图片上传中</div>
          </Spin>
          <div class="medicalHistory">
            <div class="describe" style="margin: 20px 40px">
              <span style="font-weight: 900; color: #2d8cf0">病史描述：</span>
              <Input
                v-model="bingshi"
                type="textarea"
                :disabled="IsEditBs"
                :autosize="{ minRows: 10, maxRows: 10 }"
                style="margin-top: 12px"
              />
            </div>
            <span style="margin: 12px 40px; font-weight: 900; color: #2d8cf0"
              >病史图片：</span
            >
            <div class="picBox" style="margin: 12px 40px 12px; width: 100%">
              <div class="up">
                <Upload
                  :disabled="IsEditBs"
                  ref="upload1"
                  :show-upload-list="false"
                  :on-success="handleSuccess1"
                  :before-upload="beforeUpload"
                  :format="['jpg', 'jpeg', 'png']"
                  :max-size="2048"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  multiple
                  type="drag"
                  :action="uploadfileUrl"
                  style="display: inline-block; width: 104px"
                >
                  <div
                    style="
                      width: 104px;
                      height: 104px;
                      line-height: 120px;
                      text-align: center;
                    "
                  >
                    <Icon type="ios-add" size="100"></Icon>
                  </div>
                </Upload>
              </div>
              <div class="professionalimg">
                <viewer :images="bingshiPic" class="viewer">
                  <div
                    v-for="(item, index) in bingshiPic"
                    :key="index"
                    class="Photo"
                  >
                    <img :src="item" />
                    <Modal
                      v-model="isRemove1"
                      @on-ok="handleRemove1(item)"
                      @on-cancel="cancel2"
                    >
                      <p>确定要删除吗？</p>
                    </Modal>
                    <Icon
                      v-if="!IsEditBs"
                      type="md-close"
                      size="20"
                      style="
                        position: absolute;
                        cursor: pointer;
                        background: #000;
                        border-radius: 50%;
                        opacity: 0.7;
                      "
                      @click="DelBs(item)"
                    ></Icon>
                  </div>
                </viewer>
              </div>
            </div>
            <span style="margin: 24px 40px; font-weight: 900; color: #2d8cf0"
              >上传附件:</span
            >
            <div class="accBox" style="margin: 12px 40px 0; width: 100%">
              <Upload
                ref="UploadBsAcc"
                :show-upload-list="false"
                :disabled="IsEditBs"
                multiple
                :action="uploadfileUrl"
                :on-success="handleSuccessBs"
                :on-format-error="handleFormatError1"
              >
                <Button icon="ios-cloud-upload-outline">上传</Button>
              </Upload>
              <div
                class="accCon"
                v-for="(item, index) in bsInfoAcc"
                :key="index"
              >
                <span>{{ item.name }}</span>
                <div>
                  <Button
                    :disabled="IsEditBs"
                    @click="delBsInfo(index)"
                    style="margin-right: 12px"
                    type="error"
                    ghost
                    >删除</Button
                  >
                  <Button @click="downloadFile(item.url)" type="primary" ghost
                    >下载</Button
                  >
                </div>
              </div>
            </div>
            <div v-if="sendPeopleJid == stroge.UserJid" class="bsBottom">
              <Button
                type="primary"
                style="margin-right: 50px"
                @click="EditBs"
                >{{ IsEditBs ? "编辑" : "取消编辑" }}</Button
              >
              <Button
                type="primary"
                style="margin-left: 50px"
                v-if="!IsEditBs"
                @click="saveBs"
                >保存</Button
              >
            </div>
          </div>
        </TabPane>
        <TabPane label="临床资料" tab="tab" name="3">
          <div class="clinicalData">
            <div class="lcLeft">
              <Menu
                style="height: 790px"
                :theme="theme"
                @on-select="selectLc"
                :active-name="LcTab"
              >
                <MenuItem name="全部"><span>全部</span></MenuItem>
                <MenuItem name="医院相关记录"
                  ><img src="../assets/yy.png" alt="" /><span
                    >医院相关记录</span
                  ></MenuItem
                >
                <MenuItem name="化验结果"
                  ><img src="../assets/hy.png" alt="" /><span
                    >化验结果</span
                  ></MenuItem
                >
                <MenuItem name="基因检测"
                  ><img src="../assets/jy.png" alt="" /><span
                    >基因检测</span
                  ></MenuItem
                >
                <MenuItem name="影像结果"
                  ><img src="../assets/yx.png" alt="" /><span
                    >影像结果</span
                  ></MenuItem
                >
                <MenuItem name="病理"
                  ><img src="../assets/bl.png" alt="" /><span
                    >病理</span
                  ></MenuItem
                >
                <MenuItem name="其他"
                  ><img src="../assets/qt.png" alt="" /><span
                    >其他</span
                  ></MenuItem
                >
              </Menu>
            </div>
            <div class="lcRight">
              <Button
                style="float: right; margin: 12px 0 0 0"
                type="primary"
                @click="addLcAcc"
                v-if="sendPeopleJid == stroge.UserJid"
                >新增</Button
              >
              <div v-for="(item, index) in clinical" :key="index">
                <span
                  style="color: #0165b8; font-weight: 700; font-size: 24px"
                  >{{ item.year }}</span
                >
                <div
                  v-for="(ite, index1) in item.data"
                  :key="index1"
                  class="recordList"
                  @click="recordDetail(ite)"
                >
                  <div class="box1">
                    <div :style="{ background: renderColor(ite.Category) }">
                      {{ ite.DateTime }}
                    </div>
                    <img :src="renderPic(ite.Category)" alt="" />
                  </div>
                  <div class="recordCon">{{ ite.EntryName }}</div>
                  <Button
                    v-if="sendPeopleJid == stroge.UserJid"
                    @click.stop="delLcList(ite)"
                    style="margin-left: 8px"
                    type="info"
                    ghost
                    >删除</Button
                  >
                </div>
              </div>
            </div>
            <Modal
              class-name="addData"
              v-model="addLc"
              title="添加资料"
              width="800"
              @on-cancel="addLc = false"
            >
              <div>
                <span>
                  检查时间<i style="color: red; margin-right: 4px">*</i>
                  <DatePicker
                    :disabled="sendPeopleJid != stroge.UserJid"
                    placeholder="请选择时间"
                    v-model="checkTime"
                    style="width: 212px"
                  ></DatePicker>
                </span>
              </div>
              <div style="margin-top: 24px">
                <span>
                  资料类别<i style="color: red; margin-right: 4px">*</i>
                  <Select
                    :disabled="sendPeopleJid != stroge.UserJid"
                    v-model="DataCategories"
                    style="width: 212px"
                  >
                    <Option
                      v-for="(item, index) in DataCategorieList"
                      :value="item"
                      :key="index"
                      >{{ item }}</Option
                    >
                  </Select>
                </span>
              </div>
              <div style="margin-top: 24px">
                <span>
                  项目名称<i style="color: red; margin-right: 4px">*</i>
                  <Input
                    :disabled="sendPeopleJid != stroge.UserJid"
                    v-model="projectName"
                    style="width: 212px"
                  />
                </span>
              </div>
              <div style="margin-top: 24px">
                <span>
                  项目结果
                  <Input
                    :disabled="sendPeopleJid != stroge.UserJid"
                    type="textarea"
                    :autosize="{ minRows: 6, maxRows: 6 }"
                    v-model="projectRes"
                    style="width: 400px; margin-left: 6px"
                  />
                </span>
              </div>
              <div style="margin: 24px 0 12px">
                资料图片
                <Spin size="large" fix v-if="loading">
                  <Icon
                    type="ios-loading"
                    size="18"
                    class="demo-spin-icon-load"
                  ></Icon>
                  <div>图片上传中</div>
                </Spin>
                <div class="picBox" style="margin: 12px 40px 0; width: 100%">
                  <div class="up">
                    <Upload
                      :disabled="sendPeopleJid != stroge.UserJid"
                      ref="upload3"
                      :show-upload-list="false"
                      :on-success="handleSuccess3"
                      :format="['jpg', 'jpeg', 'png']"
                      :max-size="2048"
                      :on-format-error="handleFormatError"
                      :on-exceeded-size="handleMaxSize"
                      :before-upload="beforeUpload"
                      multiple
                      type="drag"
                      :action="uploadfileUrl"
                      style="display: inline-block; width: 104px"
                    >
                      <div
                        style="
                          width: 104px;
                          height: 104px;
                          line-height: 120px;
                          text-align: center;
                        "
                      >
                        <Icon type="ios-add" size="100"></Icon>
                      </div>
                    </Upload>
                  </div>
                  <div class="professionalimg">
                    <viewer :images="lcpic" class="viewer">
                      <div
                        v-for="(item, index) in lcpic"
                        :key="index"
                        class="Photo"
                      >
                        <img :src="item" />
                        <Modal
                          v-model="isRemove3"
                          @on-ok="handleRemove3(item)"
                          @on-cancel="cancel2"
                        >
                          <p>确定要删除吗？</p>
                        </Modal>
                        <Icon
                          type="md-close"
                          size="20"
                          style="
                            position: absolute;
                            cursor: pointer;
                            background: #000;
                            border-radius: 50%;
                            opacity: 0.7;
                          "
                          @click="DelLc(item)"
                        ></Icon>
                      </div>
                    </viewer>
                  </div>
                </div>
              </div>
              <span>上传附件:</span>
              <div class="accBox" style="margin: 12px 40px 24px; width: 100%">
                <Upload
                  :disabled="sendPeopleJid != stroge.UserJid"
                  :show-upload-list="false"
                  ref="UploadAcc"
                  multiple
                  :action="uploadfileUrl"
                  :on-success="handleSuccess"

                  :on-format-error="handleFormatError1"
                >
                  <Button icon="ios-cloud-upload-outline">上传</Button>
                </Upload>
                <div
                  class="accCon"
                  v-for="(item, index) in lcInfoAcc"
                  :key="index"
                >
                  <span>{{ item.name }}</span>
                  <div>
                    <Button
                      size="small"
                      @click="delLcInfo(index)"
                      style="margin-right: 12px"
                      type="error"
                      ghost
                      >删除</Button
                    >
                    <Button
                      size="small"
                      @click="downloadFile(item.url)"
                      type="primary"
                      >下载</Button
                    >
                  </div>
                </div>
              </div>
              <div class="dicom">
                <div style="width:20%;" v-if="showDicom">
                  <p>影像图片(Dicom)</p>
                  <!-- <input type="file" id="filed" hidden="" accept=".dcm" @change="filePreview" multiple='multiple'> -->
                  <Button type="primary" style="margin:12px 0 0 36px;" @click="lookPic">查看图像</Button>
                </div>
                <!-- <div style="cursor:pointer; width:25%;" v-if="IsShowUpload">
                    <p><Icon size='30'  color="#1890FF" type="md-cloud-outline" />上传</p>
                    <div>
                        <p v-if="uploading">
                            上传中<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                        </p>
                        <div v-else>
                            <p>上传完成，已上传{{dicomNum}}张</p>
                            <p>成功{{successDicom}}张，失败{{faildDicom}}张</p>
                        </div>
                        
                        <p v-if="uploadFaild">上传失败，请尝试重新上传</p>
                    </div>
                </div> -->
                <!-- <div class="border1" :style="{borderColor:IsShowSwitch ? '#ccc':transformationSuccess?'#1890FF':'' }"  v-if="IsShowUpload"></div> -->
                <!-- <div @click="transition" style="cursor:pointer;width:25%;" v-if="IsShowUpload">
                    <p><Icon size='30' :style="{color:IsShowSwitch ? '#ccc':'#1890FF' }" type="md-sync" />转换</p>
                    <div>
                        <p v-if="transformation">
                            转换中<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                        </p>
                        <div v-if="transformationSuccess">
                            <p>转换完成，已转换{{dicomNum}}张</p>
                            <p>成功{{successDicom}}张，失败{{faildDicom}}张</p>
                        </div>
                        <p v-if="transformationFaild">转换失败，请尝试重新转换</p>
                    </div>
                </div> -->
                <!-- <div class="border2" :style="{borderColor:!transformationSuccess ? '#ccc':'#1890FF' }" v-if="IsShowUpload"></div> -->
                <!-- <div v-if="IsShowUpload" style="">
                    <p><Icon size='30' :style="{color:!transformationSuccess ? '#ccc':'#1890FF' }" type="md-checkmark-circle-outline" />完成</p>
                    <Button v-if="transformationSuccess" type="primary" @click="lookPic">查看图像</Button>
                </div> -->
              </div>
              <div slot="footer">
                <Button
                  v-if="sendPeopleJid == stroge.UserJid"
                  type="primary"
                  @click="lcSure"
                  >确定</Button
                >
              </div>
            </Modal>
          </div>
        </TabPane>
        <TabPane label="诊断及讨论" tab="tab" name="4">
          <div class="disCon">
            <div class="left">
              <div class="Lhead">
                <h2>诊断意见及手术结果</h2>
                <Button
                  v-if="IsJoin"
                  type="primary"
                  ghost
                  icon="md-add"
                  @click="creatOpinion = true"
                  >新建</Button
                >
                <Modal
                  class-name="newOpinion"
                  width="400"
                  v-model="creatOpinion"
                  @on-ok="sureOpinion"
                  @on-cancel="cancel"
                >
                  <div class="mod">
                    <img class="img1" :src="stroge.ImgUrl" alt="" />
                    <div>
                      <span>{{ stroge.DocName }}</span>
                      <span>{{ stroge.DocPosition }}</span>
                    </div>
                    <div>
                      <span>{{ stroge.HospitalName }}</span>
                      <span>{{ stroge.DepartmentName }}</span>
                    </div>
                    <div>
                      <p>诊断意见</p>
                      <Input
                        v-model="diagnosticAdvice"
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 4 }"
                        style="width: 300px"
                      />
                    </div>
                    <div>
                      <p>手术结果</p>
                      <Input
                        v-model="surgicalResuults"
                        type="textarea"
                        :autosize="{ minRows: 4, maxRows: 4 }"
                        style="width: 300px"
                      />
                    </div>
                  </div>
                </Modal>
              </div>
              <div
                class="opinionCon"
                v-for="(item, index) in DiagComAndRes"
                :key="index"
                @click="EditDiagnose(item)"
              >
                <img :src="item.DocImg" alt="" />
                <div class="docContent">
                  <div class="box1">
                    <div class="Lbox1">
                      <span>{{ item.DocName }}</span>
                      <span>{{ item.DocPosition }}</span>
                    </div>
                    <div class="Rbox1">
                      {{ item.CrtDate ? item.CrtDate.replace("T", " ") : "" }}
                    </div>
                  </div>
                  <div class="box2">
                    <span>{{ item.HospitalName }}</span>
                    <span>{{ item.DepartmentName }}</span>
                  </div>
                  <div class="box3">
                    <p>诊断意见：{{ item.Diagnosis }}</p>
                    <p>手术结果：{{ item.Surgical }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="Rhead">
                <h2>讨论列表</h2>
              </div>
              <!-- 评论区域 -->
              <div class="dicList">
                <CommentMod
                @AddOperation="AddOperation"
                  :patientName="patientName"
                  :joinDoctor="joinDoctor"
                ></CommentMod>
              </div>
            </div>
          </div>
        </TabPane>
        <!-- 案例结果 -->
        <TabPane label="案例结果" tab="tab" name="5">
          <div class="caseRes">
            <div class="finishContent">
              <div class="box" style="margin-bottom: 24px">
                <span
                  >案例类型<i style="color: red; margin-right: 4px">*</i></span
                >
                <Select
                  :disabled="caseStatus == 3"
                  v-model="caseType"
                  style="width: 400px"
                >
                  <Option value="现场指导">现场指导</Option>
                  <Option value="远程指导">远程指导</Option>
                  <Option value="转院">转院</Option>
                </Select>
              </div>
              <div class="box" style="margin-bottom: 24px">
                <span
                  >手术名称<i style="color: red; margin-right: 4px">*</i></span
                >
                <Select
                  :disabled="caseStatus == 3"
                  v-model="operation"
                  multiple
                  style="width: 400px"
                >
                  <Option
                    v-for="(item, index) in operationName"
                    :value="item.SurgicalName"
                    :key="index"
                    >{{ item.SurgicalName }}</Option
                  >
                </Select>
              </div>
              <div class="box">
                <span style="margin-right: 4px"
                  >案例结论<i style="color: red; margin-right: 1px">*</i></span
                >
                <Input
                  :disabled="caseStatus == 3"
                  v-model="caseCon"
                  type="textarea"
                  :autosize="{ minRows: 5, maxRows: 5 }"
                  style="width: 400px"
                />
              </div>
            </div>
            <div class="caseResBtn">
              <Button
                v-if="IsJoin"
                type="primary"
                :disabled="caseStatus == 3"
                @click="finishDiscussion"
                >提交</Button
              >
            </div>
          </div>
        </TabPane>
        <!-- 随访 -->
        <TabPane label="随访" tab="tab" name="6">
          <div class="follow">
            <div class="folHead">
              <h2>随访记录</h2>
              <Button
                v-if="IsJoin"
                type="primary"
                :disabled="caseStatus == 1 || IsFolBtn"
                icon="md-add"
                @click="follow = true"
                >添加随访计划</Button
              >
              <Modal v-model="follow" title="随访计划">
                <div>
                  <span>
                    随访时间<i style="color: red; margin-right: 4px">*</i>
                    <DatePicker
                      placeholder="请选择时间"
                      v-model="followTime"
                      style="width: 300px"
                    ></DatePicker>
                  </span>
                </div>
                <div style="margin-top: 24px">
                  <span>
                    随访内容<i style="color: red; margin-right: 4px">*</i>
                    <Input v-model="followCon" style="width: 300px" />
                  </span>
                </div>
                <div slot="footer">
                  <Button type="text" @click="follow = false">取消</Button>
                  <Button type="primary" @click="addFollow">确定</Button>
                </div>
              </Modal>
            </div>
            <div class="folCon">
              <Timeline>
                <TimelineItem v-for="(item, index) in FollowPlan" :key="index">
                  <div @click="FolNote(item)" style="cursor: pointer">
                    <div class="time">
                      <p>{{ item.NextFollowUpDate }}</p>
                      <p
                        :class="{
                          tag: true,
                          tag1: item.IsFollowUp == '否', //随访中
                          tag2: item.IsFollowUp == '是',
                        }"
                      >
                        {{ item.IsFollowUp == "否" ? "随访中" : "已完成" }}
                      </p>
                    </div>
                    <p class="content">
                      随访内容：<span>{{ item.FollowUpContent }}</span>
                    </p>
                  </div>
                </TimelineItem>
              </Timeline>
              <Modal
                footer-hide
                class-name="folNote"
                v-model="folNote"
                title="维护随访内容"
                width="700"
                @on-cancel="cancelFol"
                :footer-hide="IsFooter == '是'"
              >
                <div>
                  <span>
                    随访时间<i style="color: red; margin-right: 4px">*</i>
                    <DatePicker
                      placeholder="请选择时间"
                      v-model="followNoteTime"
                      style="width: 212px"
                    ></DatePicker>
                  </span>
                </div>
                <div style="margin-top: 24px">
                  <span>
                    随访内容<i style="color: red; margin-right: 4px">*</i>
                    <Input v-model="followNoteCon" style="width: 212px" />
                  </span>
                </div>
                <div style="margin-top: 24px">
                  <span>
                    随访结果
                    <Input
                      type="textarea"
                      :autosize="{ minRows: 6, maxRows: 6 }"
                      v-model="followNoteRes"
                      style="width: 400px; margin-left: 6px"
                    />
                  </span>
                </div>
                <div style="margin-top: 24px">
                  资料图片
                  <Spin size="large" fix v-if="loading">
                    <Icon
                      type="ios-loading"
                      size="18"
                      class="demo-spin-icon-load"
                    ></Icon>
                    <div>图片上传中</div>
                  </Spin>
                  <Row :gutter="64">
                    <Col span="4"
                      ><Upload
                        ref="upload2"
                        :show-upload-list="false"
                        :default-file-list="defaultList2"
                        :on-success="handleSuccess2"
                        :format="['jpg', 'jpeg', 'png']"
                        :max-size="2048"
                        :on-format-error="handleFormatError"
                        :before-upload="beforeUpload"
                        :on-exceeded-size="handleMaxSize"
                        multiple
                        type="drag"
                        :action="uploadfileUrl"
                        style="display: inline-block; width: 104px"
                      >
                        <div
                          style="
                            width: 104px;
                            height: 104px;
                            line-height: 120px;
                            text-align: center;
                          "
                        >
                          <Icon type="ios-add" size="100"></Icon>
                        </div> </Upload
                    ></Col>
                    <!-- <Col span="4">
                          <div
                            class="professionalimg"
                            style="position: relative"
                          >
                            <img :src="professionalpicture" />
                            <div
                              class="imgbot1"
                              @click="showprofessionalpicture"
                            >
                              示例图<Icon
                                type="ios-search-outline"
                                size="20"
                                style="margin-top: 15px; margin-left: 10px"
                              ></Icon>
                            </div>
                          </div>
                        </Col> -->
                    <Col
                      span="4"
                      offset="0.5"
                      v-for="item in professionalList"
                      :key="item.url"
                    >
                      <div class="professionalimg">
                        <Poptip
                          confirm
                          title="确定要删除吗？"
                          @on-ok="ok2(item)"
                          @on-cancel="cancel2"
                        >
                          <Icon
                            type="md-close"
                            size="20"
                            style="
                              position: absolute;
                              background: #000;
                              border-radius: 50%;
                              top: -102px;
                              right: -100px;
                              opacity: 0.7;
                            "
                          ></Icon>
                        </Poptip>
                        <img
                          style="width: 100%; height: 100%"
                          @click="showprofessional(item)"
                          :src="item.url"
                        />
                      </div>
                    </Col>
                  </Row>
                </div>
                <div
                  style="
                    margin-top: 18px;
                    font-size: 20px;
                    font-weight: 900;
                    color: #1890ff;
                  "
                  v-if="IsFooter == '否'"
                >
                  随访计划
                </div>
                <div style="margin-top: 24px" v-if="IsFooter == '否'">
                  <span>
                    随访类型:
                    <RadioGroup v-model="folType" style="margin-left: 24px">
                      <Radio label="停止随访">停止随访</Radio>
                      <Radio label="继续随访">继续随访</Radio>
                    </RadioGroup>
                    <div v-if="folType == '继续随访'">
                      <div style="margin-top: 24px">
                        <span>
                          下次随访时间：
                          <DatePicker
                            placeholder="请选择时间"
                            v-model="nextFollowNoteTime"
                            style="width: 212px"
                          ></DatePicker>
                        </span>
                      </div>
                      <div style="margin-top: 24px">
                        <span>
                          随访内容：
                          <Input
                            v-model="nextFollowCon"
                            style="width: 212px; margin-left: 28px"
                          />
                        </span>
                      </div>
                    </div>
                  </span>
                </div>
                <div slot="footer">
                  <Button type="primary" @click="folNoteSure">确定</Button>
                </div>
              </Modal>
              <div
                class="folhint"
                v-if="FollowPlan.length == 0"
                style="color: gainsboro"
              >
                暂无随访记录
              </div>
            </div>
          </div>
        </TabPane>
        <Button
          type="primary"
          ghost
          icon="ios-videocam"
          slot="extra"
          @click="VideoDis"
          >视频讨论</Button
        >
        <Modal title="查看图片" v-model="visible">
          <img :src="imgName" v-if="visible" style="width: 100%" />
        </Modal>
      </Tabs>
    </div>
  </div>
</template>

<script>
import Request from "../utils/request";
import Config from "../config/index";
//获取个人信息、结束讨论的手术名称、操作历史列表、邀请医生列表、病史、诊断意见、随访计划 (完成)
const getPersonInfo = Config.SXG_baseUrl + "/api/currency/GetRecordDetail";
const getFinishDic = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //结束讨论、新建诊断意见
const getPartDoctor = Config.SXG_baseUrl + "/api/casemanager/GetPartakeDocList"; //获取参与医生列表（完成）
const sureGetDoctor = Config.SXG_baseUrl + "/api/casemanager/InviteDoc"; //确定邀请医生接口（完成）
const newFollowPlan = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //新建随访计划（完成）
const editFollowPlan = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //编辑新建或停止随访计划（完成）
const SaveCase = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //编辑保存个人信息
const getMedicalHistory = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //编辑保存病史
const getClinicalData = Config.SXG_baseUrl + "/api/currency/UpdateRecord"; //编辑保存临床资料
const AddOperation = Config.SXG_baseUrl + "/api/casemanager/AddOperation"; //编辑保存信息的操作历史
const GetCaseClinical = Config.SXG_baseUrl + "/api/casemanager/GetCaseClinical"; //获取临床资料信息
const DeleteRecord = Config.SXG_baseUrl + "/api/currency/DeleteRecord"; //删除临床资料列表
import _ from "lodash";
import CommentMod from "../components/CommentMod";
import Base64 from "base-64"
import {
  Tabs,
  TabPane,
  Button,
  Modal,
  Select,
  Option,
  Input,
  RadioGroup,
  Radio,
  Row,
  Col,
  Tag,
  Checkbox,
  CheckboxGroup,
  Icon,
  DatePicker,
  List,
  Timeline,
  TimelineItem,
  FormItem,
  Upload,
  Poptip,
  Form,
  Spin,
  Menu,
  MenuItem,
  InputNumber,
  Divider,
  Steps,
  Step  
} from "view-design";
import dayjs from "dayjs";

export default {
  components: {
    Tabs,
    TabPane,
    Button,
    Modal,
    Select,
    Option,
    Input,
    RadioGroup,
    Radio,
    Row,
    Col,
    Tag,
    Checkbox,
    CheckboxGroup,
    Icon,
    DatePicker,
    List,
    ListItem: List.Item,
    Timeline,
    TimelineItem,
    FormItem,
    Upload,
    Poptip,
    Form,
    CommentMod,
    Spin,
    Menu,
    MenuItem,
    InputNumber,
    Divider,
    Steps,
    Step  
  },
  data() {
    return {
        showDicom:true,
      dicomUrl:"",  
      current:0,
      dicomNum:"500",
      successDicom:"490",
      faildDicom:"10",  
      isLookPic: "", //是否显示查看图像按钮
      IsJoin: false, //是否是参与医生
      LcTab: "全部",
      IsAdd: true, //新增临床资料标识
      ClinicalID: "",
      bsInfoAcc: [], //病史附件
      lcInfoAcc: [], //临床资料附件
      clinical: [], //临床资料详情
      colors: [
        "#D4607B",
        "#158FE9",
        "#ECB147",
        "#5BBD00",
        "#F47451",
        "#009999",
      ],
      projectRes: "", //项目结果
      projectName: "", //项目名称
      checkTime: "", //检查时间
      DataCategories: "", //资料类别
      DataCategorieList: [
        "医院相关记录",
        "化验结果",
        "基因检测",
        "影像结果",
        "病理",
        "其他",
      ], //资料类别列表
      addLc: false,
      theme: "light",
      loading: false,
      uploadfileUrl: Config.SXG_baseUrl + "/api/currency/uploadfile",
      uploadDicom: Config.SXG_baseUrl + "/api/currency/uploadfile2",
      DelBsPic: "",
      DelLcPic: "",
      doctorShowName: "", //邀请医生的名字
      doctorShowUserJid: [], //邀请医生的UserJid
      tabName: "1",
      BsID: "", //病史ID
      LcID: "", //临床资料ID
      bingshiPic1: "",
      lcInfoPic1: "",
      SaveCaseID: "", //编辑保存个人信息的ID
      diagnoseID: "", //诊断意见的ID
      IsEditBs: true, //编辑病史
      IsDisabled: true, //编辑个人信息
      stroge: JSON.parse(localStorage.getItem("Role")),
      operationInfo: [], //操作历史详情
      partDoctorInfo: {
        DocImg: "",
        DocName: "",
        DocPosition: "",
        HospitalName: "",
        DepartmentName: "",
        Position: "",
        Intro: "",
        GoodAt: "",
        TeamName: "",
      }, //参与医生的详情
      sendPeopleJid: "", //发起人的Jid
      sendPeopleName: "", //发起人姓名
      sendPeopleId: "", //发起人id
      IsFooter: "", //是否显示模态框底部
      FollowPlanId: "", //案例记录的id
      caseStatus: "", //案例状态
      // newOpinId: "", //新建诊断意见的id
      PartakeDoc: "", //个人信息
      allPartakeDoc: "", //总个人信息
      bingshi: "", //病史描述
      id: this.$route.params.id,
      caseType: "", //案例类型
      operation: [], //选中的手术
      operationName: [], //手术名称
      caseCon: "", //案例结论
      patientName: "", //患者姓名
      sex: "", //患者性别
      patientAge: 0, //患者年龄
      stature: "", //身高
      weight: "", //体重
      nation: "", //民族
      occupation: "", //职业
      occupationArr: [
        { label: "工人", value: "工人" },
        { label: "农民", value: "农民" },
        { label: "教师", value: "教师" },
        { label: "管理/科技人员", value: "管理/科技人员" },
        { label: "医务人员", value: "医务人员" },
        { label: "学生", value: "学生" },
        { label: "军人", value: "军人" },
        { label: "个体", value: "个体" },
        { label: "其它", value: "其它" },
      ],
      maritalStatus: "", //婚姻状况
      auditingSystem: "", //检查系统
      systemName: [
        { label: "运动系统", value: "运动系统" },
        { label: "消化系统", value: "消化系统" },
        { label: "呼吸系统", value: "呼吸系统" },
        { label: "泌尿系统", value: "泌尿系统" },
        { label: "生殖系统", value: "生殖系统" },
        { label: "内分泌系统", value: "内分泌系统" },
        { label: "免疫系统", value: "免疫系统" },
        { label: "神经系统", value: "神经系统" },
        { label: "循环系统", value: "循环系统" },
      ], //检查系统名称
      action: "", //主诉
      selectDoc: false, //邀请医生弹窗
      checkdoctorList: [],
      checkdoctor: [], //所有医生
      doctorList: [], //每一个医生
      searchvalue: "", //输入的医生姓名
      indeterminate: false,
      checkAll: false,
      onindex: "",
      joinDoctor: [], //参与医生
      DocUserJid: [], //参与医生的UserJid
      doctorDetail: false, //医生详细信息的弹窗
      creatOpinion: false, //新建诊断意见弹窗
      diagnosticAdvice: "", //诊断意见
      surgicalResuults: "", //手术结果
      // LoginDocInfo:[],//新建诊断意见人的信息
      DiagComAndRes: [], //诊断意见及手术结果
      follow: false, //添加随访计划弹窗
      followTime: "", //初次随访的时间
      followCon: "", //随访内容
      FollowPlan: [], //随访记录
      folNote: false, //随访记录的弹窗
      followNoteTime: "", //随访记录时间
      followNoteCon: "", //随访记录内容
      followNoteRes: "", //随访记录结果
      followNoteUserJid: "", //维护人的UserJid
      followNoteDocName: "", //维护人的名字
      folType: "", //随访类型
      nextFollowNoteTime: "", //下次随访时间
      nextFollowCon: "", //下次随访内容
      visible: false,
      imgName: "",
      professionalpicture:
        "http://www.sino-med.net:5049/Applications/494cccf4-2726-4952-a26e-9c1361f2a82e/AppFiles/AnymedStore/2021/03/03/16147619669399354.png", //示例图片地址
      professionalList: [], //接受图片的地址
      //FollowPlanPic: "", //随访记录图片
      defaultList2: [],
      bingshiPic: [], //病史图片
      lcpic: [], //临床资料的图片
      isRemove2: false,
      isRemove1: false,
      isRemove3: false,
      IsFolBtn: false,
      IsShowUpload:false,
      IsShowSwitch:true,
      transformation:false,
      transformationSuccess:false,
      uploading:false,
      uploadFaild:false,
      transformationFaild:false,
      inde:0,
      catalogArr: [],//类目数组
	  catalogObj: {},//嵌套对象
      //聊天组件
    };
  },
  computed: {
    doctorShow() {
      var newarr = [];
      newarr = _.intersectionWith(
        this.doctorList,
        this.checkdoctor,
        function (key, val) {
          return key.UserJid == val;
        }
      );
      return newarr;
    },
  },
  methods: {
    AddOperation(){
    
    this.GetInfo(3); //操作历史
    },
    addLcAcc() {
        this.showDicom = false
      this.addLc = true;
      this.IsAdd = true;
      this.checkTime = "";
      this.DataCategories = "";
      this.projectName = "";
      this.projectRes = "";
      this.lcpic = [];
      this.lcInfoAcc = [];
      this.$refs.UploadAcc.clearFiles();

    },
    //选择上传的文件 
    // filePreview(e){
    //     let files = e.target.files
    //     let arr = Array.from(files)
    //     if(arr.length){
    //         this.sendImages(arr)
    //     }
    // },
    //上传文件到服务器
    // sendImages(imageFiles) {
    //     // this.DicomArr = []
    //     this.uploading = true
    //     this.IsShowUpload = true
    //     var _this = this
    //     return Promise.all(imageFiles.map((imageFile) => {
    //         return new Promise(function (resolve, reject) {
    //             let formData = new window.FormData(); 
    //             formData.append('files',imageFile)
    //             formData.append('CID',1)
    //             Request.postRequest(_this.uploadDicom,formData).then(res=>{
    //                 if(res.code == 200){
    //                     console.log(res)
    //                     _this.uploading = false
    //                     _this.dicomNum=res.data
    //                 }else{

    //                 }
    //             })
    //         })
    //     }))
    // },
    //上传图像
    // uploadPic(){
    //     document.getElementById('filed').click()
    // },
    
    //转换图像
    // transition(){
    //     this.IsShowSwitch = false
    //     this.transformation = true
    //     setTimeout(() => {
    //         this.transformationSuccess = true
    //         this.transformation = false
    //     }, 1000);
        
    // },
    //查看dicom图像
    lookPic() {
      window.open("https://www.elismed.com:777/pacspc/index?StudyInstUID=" + this.dicomUrl)
      
    },
    //下载文件
    downloadFile(url) {
      let link = document.createElement("a");
      fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
          link.href = URL.createObjectURL(blob);
          // console.log(link.href)
          link.download = "";
          document.body.appendChild(link);
          link.click();
        });
      link.style.display = "none";
      URL.revokeObjectURL(link.href); //释放掉blob对象
    },
    handleFormatError1(file) {
      this.$Notice.warning({
        title: "文件格式不正确!",
        desc: file.name + "的文件格式不正确",
      });
    },
    //临床资料删除附件
    delLcInfo(data) {
      this.lcInfoAcc.splice(data, 1);
    },
    //临床资料上传附件成功的回调
    handleSuccess(response, file, fileList) {
      console.log(file);
      if (file.response.code == 200) {
        this.lcInfoAcc.push({ name: file.name, url: file.response.data[0] });
      } else {
        this.$Message.error(file.response.message);
      }
    },
    //临床资料颜色
    renderColor(pic) {
      if (pic == "医院相关记录") {
        return "#737DFD";
      } else if (pic == "化验结果") {
        return "#FF8A80";
      } else if (pic == "基因检测") {
        return "#0088DE";
      } else if (pic == "影像结果") {
        return "#D4607B";
      } else if (pic == "病理") {
        return "#01BF95";
      } else if (pic == "其他") {
        return "#67C23A";
      }
    },
    // //临床资料标识图
    renderPic(pic) {
      if (pic == "医院相关记录") {
        return require("../assets/yy.png");
      } else if (pic == "化验结果") {
        return require("../assets/hy.png");
      } else if (pic == "基因检测") {
        return require("../assets/jy.png");
      } else if (pic == "影像结果") {
        return require("../assets/yx.png");
      } else if (pic == "病理") {
        return require("../assets/bl.png");
      } else if (pic == "其他") {
        return require("../assets/qt.png");
      }
    },
    //随机颜色函数
    randomColor() {
      var str = Math.floor(Math.random() * this.colors.length);
      return this.colors[str];
    },
    //删除临床资料列表
    delLcList(data) {
      Request.postRequest(DeleteRecord, {
        ID: data.ID,
        tablename: "Clinical",
        type: "1",
      }).then((res) => {
        if (res.code == 200) {
          console.log("删除成功");
          this.GetCaseClinical(this.LcTab);
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //临床资料记录详情
    recordDetail(data) {
      console.log(data)
      this.showDicom = true
      //   this.isLookPic = data.Category
      this.dicomUrl = data.StuyUID
      this.IsAdd = false;
      this.ClinicalID = data.ID;
      this.addLc = true;
      this.checkTime = `${data.Year}-${data.DateTime.split(/月|日/g)[0]}-${
        data.DateTime.split(/月|日/g)[1]
      }`;
      this.DataCategories = data.Category;
      this.projectName = data.EntryName;
      this.projectRes = data.Results;
      this.lcpic = data.ImgUrl == "" ? [] : JSON.parse(data.ImgUrl);
      this.lcInfoAcc = data.Annex == null || "" ? [] : JSON.parse(data.Annex);

    },
    //修改临床资料记录
    lcSure() {
      if (this.checkTime == "") {
        return this.$Message.info("请选择检查时间");
      }
      if (this.DataCategories == "") {
        return this.$Message.info("请选择资料类别");
      }
      if (this.projectName == "") {
        return this.$Message.info("请输入项目名称");
      }
      this.addLc = false;
      this.getClinicalData();
    },
    //保存临床资料
    getClinicalData() {
      let obj = {};
      if (this.IsAdd) {
        obj = {
          ID: "",
          tablename: "Clinical",
          CaseID: this.id,
          Results: this.projectRes,
          ImgUrl: JSON.stringify(this.lcpic),
          Year: dayjs(this.checkTime).format("YYYY"),
          DateTime: dayjs(this.checkTime).format("YYYY-MM-DD"),
          Category: this.DataCategories,
          EntryName: this.projectName,
          Annex: this.lcInfoAcc.length ? JSON.stringify(this.lcInfoAcc) : "[]", //附件
        };
      } else {
        obj = {
          ID: this.ClinicalID,
          tablename: "Clinical",
          CaseID: this.id,
          Results: this.projectRes,
          ImgUrl: JSON.stringify(this.lcpic),
          Year: dayjs(this.checkTime).format("YYYY"),
          DateTime: dayjs(this.checkTime).format("YYYY-MM-DD"),
          Category: this.DataCategories,
          EntryName: this.projectName,
          Annex: this.lcInfoAcc.length ? JSON.stringify(this.lcInfoAcc) : "[]", //附件
        };
      }
      Request.postRequest(getClinicalData, obj).then((res) => {
        if (res.code == 200) {
          // this.IsAdd = true
          console.log(res, "临床");
          if (this.IsAdd == false) {
            Request.postRequest(AddOperation, {
              CaseID: this.id,
              Dynamic: `<span>${this.stroge.DocName}</span>修改了临床资料<em>${this.patientName}</em>`,
              OperationHis: `<span>${this.stroge.DocName}</span>修改了临床资料`,
              OUserJid: this.stroge.UserJid,
              ODocName: this.stroge.DocName,
              Type: "修改信息",
              OImg: this.stroge.ImgUrl,
            }).then((res) => {
              if (res.code == 200) {
                console.log("临床资料操作历史");
                this.GetInfo(3); //操作历史
              } else {
                this.$Message.error(res.message);
              }
            });
          }

          if (this.LcTab == "全部") {
            this.GetCaseClinical("全部");
          } else {
            this.GetCaseClinical(this.DataCategories);
          }
        }
      });
    },
    //获取临床资料详情
    GetCaseClinical(IsTab) {
      // this.clinical = []
      Request.getRequest(GetCaseClinical, {
        CaseID: this.id,
        Category: IsTab == "全部" ? "" : IsTab,
      }).then((res) => {
        if (res.code == 200) {
          this.LcTab = IsTab;
        //   console.log(res, "获取临床资料");
          res.data.map((item) => {
            item.color = this.randomColor();
            item.data.map((ite) => {
              ite.DateTime = dayjs(ite.DateTime).format("MM月DD日");
            });
          });
          this.clinical = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    // cancelLc(){
    //   this.addLc = false
    // },
    //选择临床资料列表
    selectLc(name) {
    //   console.log(name);
      // this.isLookPic  = name
      this.LcTab = name;
      this.GetCaseClinical(name);
    },
    browseNotice(name) {
      //console.log(name)
      if (name == "2") {
      } else if (name == "3") {
      } else if (name == "4") {
      } else if (name == "5") {
      } else if (name == "6") {
        console.log(this.FollowPlan);
      }
    },
    //视频讨论
    VideoDis() {
      window.location.href = `anymedwan://MedLink_{'From':'AnyImage','BizType':'Integrate','Action':'IC','Args':[{'ID':${this.stroge.UserJid},'TargetID':'','ICType':'Common','StudyURL':'','StudyDes':'','Fields':''}]}`;
    },
    //获取详细信息
    GetInfo(IsDetail) {
      let Obj = {};
      //个人信息
      if (IsDetail == 1) {
        Obj = {
          tablename: "CaseList",
          searchkey2: "ID",
          searchvalue2: this.id,
        };
      }
      //手术名称
      else if (IsDetail == 2) {
        Obj = {
          tablename: "SurgicalDict",
          fields: "SurgicalName",
        };
      }
      //操作历史
      else if (IsDetail == 3) {
        Obj = {
          tablename: "Operation",
          searchkey2: "CaseID",
          searchvalue2: this.id,
        };
      }
      //邀请医生
      else if (IsDetail == 4) {
        Obj = {
          tablename: "DocList",
          fields: "ID,UserJid,DocName,ImgUrl",
          searchkey2: "DocType",
          searchvalue2: "中心",
          searchkey3: "CenterID",
          searchvalue3: this.stroge.CenterID,
        };
      }
      //病史
      else if (IsDetail == 5) {
        Obj = {
          tablename: "MedicalHistory",
          searchkey2: "CaseID",
          searchvalue2: this.id,
        };
      }
      // //案例资料
      // else if (IsDetail == 6) {
      //   Obj = {
      //     tablename: "Clinical",
      //     searchkey2: "CaseID",
      //     searchvalue2: this.id,
      //   };
      // }
      //诊断意见
      else if (IsDetail == 7) {
        Obj = {
          tablename: "DiagnosisAndSurgical",
          searchkey2: "CaseID",
          searchvalue2: this.id,
        };
      }
      //随访计划
      else if (IsDetail == 8) {
        Obj = {
          tablename: "FollowUp",
          searchkey2: "CaseID",
          searchvalue2: this.id,
        };
      }
      Request.getRequest(getPersonInfo, Obj).then((res) => {
        if (res.code == 200) {
          if (IsDetail == 1) {
            // console.log(res, "获取个人信息");
            this.caseType = res.data[0].CaseType;
            this.operation = res.data[0].SurgicalName
              ? JSON.parse(res.data[0].SurgicalName)
              : "";
            this.caseCon = res.data[0].Result;
            this.SaveCaseID = res.data[0].ID;
            this.caseStatus = res.data[0].Status;
            this.sendPeopleJid = res.data[0].DocUserJid;
            this.sendPeopleName = res.data[0].DocName;
            this.sendPeopleId = res.data[0].DocID;
            this.PartakeDoc = res.data[0].PartakeDoc
              ? res.data[0].PartakeDoc
              : "[{}]"; //参与医生
            this.DocUserJid.unshift(res.data[0].DocUserJid); //登陆人
            // res.data[0].PartakeDoc;
            JSON.parse(this.PartakeDoc).map((item) => {
              this.DocUserJid.push(item.UserJid);
            });
            //console.log(this.DocUserJid, 12121212);
            this.getPartDoctor();
            res.data.map((item) => {
              this.patientName = item.PatientName;
              this.sex = item.Gender;
              this.patientAge = item.Age;
              this.stature = item.Height;
              this.weight = item.Weight;
              this.nation = item.Nation;
              this.occupation = item.Occupation; //职业
              this.maritalStatus = item.Marital;
              this.auditingSystem = item.CheckSys;
              this.action = item.Complaint;
            });
          } else if (IsDetail == 2) {
            //结束讨论的手术名称
            //console.log(res)
            this.operationName = res.data;
            this.$forceUpdate();
          } else if (IsDetail == 3) {
            //操作历史列表
            //console.log(res,'操作历史列表')
            if (res.data.length != 0) {
              this.operationInfo = [];
              res.data.map((item) => {
                if (item.OperationHis != null || item.OperationHis) {
                  this.operationInfo.push(item);
                }
              });
              //console.log(this.operationInfo, 12121212);
            }
          }
          //邀请医生
          else if (IsDetail == 4) {
            let newarr = [];
            for (var i = 0; i < res.data.length; i++) {
              var vote = {
                ID: res.data[i].ID,
                DocName: res.data[i].DocName,
                Img: res.data[i].ImgUrl,
                UserJid: res.data[i].UserJid,
              };
              newarr.push(vote);
            }
            this.checkdoctorList = res.data.map((item) => {
              return item.UserJid;
            });
            this.doctorList = newarr;
            // console.log(this.doctorList,11111111111111)
            // console.log(this.joinDoctor,22222222222222)
            for (var i = 0; i < this.doctorList.length; i++) {
              for (var j = 0; j < this.joinDoctor.length; j++) {
                if (this.doctorList[i].UserJid == this.joinDoctor[j].UserJid) {
                  this.doctorList[i].IsChoose = "T";
                }
              }
            }
          }
          //病史
          else if (IsDetail == 5) {
            // console.log(res, "病史");
            this.BsID = res.data.length != 0 ? res.data[0].ID : "";
            this.bingshi =
              res.data.length != 0 ? res.data[0].DiseaseContent : "";
            this.bingshiPic =
              res.data.length == 0
                ? []
                : res.data[0].DiseaseImg == ""
                ? []
                : JSON.parse(res.data[0].DiseaseImg);
            this.bsInfoAcc =
              res.data.length == 0
                ? []
                : res.data[0].Annex == "" || res.data[0].Annex == null
                ? []
                : JSON.parse(res.data[0].Annex);
          }
          // //案例详情
          // else if (IsDetail == 6) {
          //   //console.log(res,"临床资料")
          //   this.LcID = res.data.length != 0 ? res.data[0].ID : "";
          //   this.lcInfo = res.data.length != 0 ? res.data[0].Results : "";
          //   this.lcpic =
          //     res.data.length == 0
          //       ? []
          //       : res.data[0].ImgUrl == ""
          //       ? []
          //       : JSON.parse(res.data[0].ImgUrl);
          // }
          //诊断意见
          else if (IsDetail == 7) {
            //console.log(res, "诊断意见");
            this.DiagComAndRes = res.data;
          }
          //随访计划
          else if (IsDetail == 8) {
            // console.log(res, "获取随访计划");
            res.data.map((item) => {
              item.NextFollowUpDate = dayjs(item.NextFollowUpDate).format(
                "YYYY-MM-DD"
              );
            });
            // console.log(res.data);
            this.FollowPlan = res.data;
            this.FollowPlan.map((item) => {
              if (item.IsFollowUp == "否") {
                this.IsFolBtn = true;
              } else {
                this.IsFolBtn = false;
              }
            });
          }
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //编辑和保存病史
    saveBs() {
      Request.postRequest(getMedicalHistory, {
        tablename: "MedicalHistory",
        CaseID: this.id,
        DiseaseContent: this.bingshi,
        DiseaseImg: JSON.stringify(this.bingshiPic),
        ID: this.BsID,
        Annex: this.bsInfoAcc.length ? JSON.stringify(this.bsInfoAcc) : "[]",
      }).then((res) => {
        if (res.code == 200) {
          // console.log(res,"病史")
          this.GetInfo(5); //病史
          this.IsEditBs = true;
          Request.postRequest(AddOperation, {
            PageNum: "2",
            CaseID: this.id,
            Dynamic: `<span>${this.stroge.DocName}</span>修改了病史<em>${this.patientName}</em>`,
            OperationHis: `<span>${this.stroge.DocName}</span>修改了病史`,
            OUserJid: this.stroge.UserJid,
            ODocName: this.stroge.DocName,
            Type: "修改信息",
            OImg: this.stroge.ImgUrl,
            CenterID: this.stroge.CenterID,
          }).then((res) => {
            if (res.code == 200) {
              //console.log("病史操作历史")
              this.GetInfo(3); //操作历史
            } else {
              this.$Message.error(res.message);
            }
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //编辑个人信息
    Disabled() {
      if (!this.IsDisabled) {
        this.GetInfo(1);
      }
      this.IsDisabled = !this.IsDisabled;
    },
    //编辑病史
    EditBs() {
      if (!this.IsEditBs) {
        this.GetInfo(5);
      }
      this.IsEditBs = !this.IsEditBs;
    },
    //编辑保存个人信息
    savePerInfo() {
      Request.postRequest(SaveCase, {
        tablename: "CaseList",
        ID: this.SaveCaseID,
        PatientName: this.patientName,
        Gender: this.sex,
        Age: this.patientAge,
        Height: this.stature,
        Weight: this.weight,
        Nation: this.nation,
        Marital: this.maritalStatus,
        Occupation: this.occupation,
        CheckSys: this.auditingSystem,
        Complaint: this.action,
        DocUserJid: this.sendPeopleJid,
        DocID: this.sendPeopleId,
        DocName: this.sendPeopleName,
      }).then((res) => {
        if (res.code == 200) {
          //console.log(res, "编辑保存成功");
          this.IsDisabled = true;

          Request.postRequest(AddOperation, {
            PageNum: "1",
            CaseID: this.id,
            Dynamic: `<span>${this.stroge.DocName}</span>修改了个人信息<em>${this.patientName}</em>`,
            OperationHis: `<span>${this.stroge.DocName}</span>修改了个人信息`,
            OUserJid: this.stroge.UserJid,
            ODocName: this.stroge.DocName,
            Type: "修改信息",
            OImg: this.stroge.ImgUrl,
            CenterID: this.stroge.CenterID,
          }).then((res) => {
            if (res.code == 200) {
              //console.log("个人信息操作历史")
              this.GetInfo(3); //操作历史
            } else {
              this.$Message.error(res.message);
            }
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //编辑保存诊断结果
    EditDiagnose(item) {
      //console.log(item);
      this.diagnoseID = item.ID;
      this.creatOpinion = true;
      this.diagnosticAdvice = item.Diagnosis;
      this.surgicalResuults = item.Surgical;
    },
    //编辑或结束信息
    EditAndFinishInfo(IsFinish) {
      let str = {};
      //结束讨论
      if (IsFinish == 1) {
        str = {
          tablename: "CaseList",
          ID: this.id,
          Status: 2,
          CaseType: this.caseType,
          SurgicalName: JSON.stringify(this.operation),
          Result: this.caseCon,
        };
      }
      //新建诊断意见
      else if (IsFinish == 2) {
        str = {
          tablename: "DiagnosisAndSurgical",
          CaseID: this.id,
          Diagnosis: this.diagnosticAdvice,
          Surgical: this.surgicalResuults,
          DocID: this.stroge.ID,
          DocUserJid: this.stroge.UserJid,
          DocName: this.stroge.DocName,
          DocPosition: this.stroge.DocPosition,
          HospitalName: this.stroge.HospitalName,
          DepartmentName: this.stroge.DepartmentName,
          DocImg: this.stroge.ImgUrl,
        };
      } else if (IsFinish == 3) {
        str = {
          tablename: "DiagnosisAndSurgical",
          CaseID: this.id,
          Diagnosis: this.diagnosticAdvice,
          Surgical: this.surgicalResuults,
          DocID: this.stroge.ID,
          DocUserJid: this.stroge.UserJid,
          DocName: this.stroge.DocName,
          DocPosition: this.stroge.DocPosition,
          HospitalName: this.stroge.HospitalName,
          DepartmentName: this.stroge.DepartmentName,
          DocImg: this.stroge.ImgUrl,
          ID: this.diagnoseID,
        };
      }
      Request.postRequest(getFinishDic, str).then((res) => {
        if (res.code == 200) {
          //结束讨论
          if (IsFinish == 1) {
            //console.log(res, "结束讨论");
            this.$Message.info("已结束讨论");
            this.caseType = "";
            this.operation = "";
            this.caseCon = "";
            this.$router.push(`/HomePage/CaseDiscussion/tab_2`);
            Request.addLog("案例管理", "结束案例");
            Request.postRequest(AddOperation, {
              PageNum: "5",
              CaseID: this.id,
              Dynamic: `<span>${this.stroge.DocName}</span>结束<em>${this.patientName}</em>的案例讨论`,
              OperationHis: `<span>${this.stroge.DocName}</span>结束了讨论`,
              OUserJid: this.stroge.UserJid,
              ODocName: this.stroge.DocName,
              Type: "结束案例",
              OImg: this.stroge.ImgUrl,
              CenterID: this.stroge.CenterID,
            }).then((res) => {
              if (res.code == 200) {
                //console.log("诊断意见操作历史")
                this.GetInfo(3); //操作历史
              } else {
                this.$Message.error(res.message);
              }
            });
          }
          //新建诊断意见
          else if (IsFinish == 2) {
            //console.log(res,'新建诊断意见成功111111111111111111111111')
            this.GetInfo(7);
            (this.diagnosticAdvice = ""), (this.surgicalResuults = "");
            Request.postRequest(AddOperation, {
              PageNum: "4",
              CaseID: this.id,
              Dynamic: `<span>${this.stroge.DocName}</span>在<em>${this.patientName}</em>的案例添加新的<em>诊断</em>`,
              OperationHis: `<span>${this.stroge.DocName}</span>书写新的<em>诊断</em>`,
              OUserJid: this.stroge.UserJid,
              ODocName: this.stroge.DocName,
              Type: "添加诊断",
              OImg: this.stroge.ImgUrl,
              CenterID: this.stroge.CenterID,
            }).then((res) => {
              if (res.code == 200) {
                //console.log("诊断意见操作历史")
                this.GetInfo(3); //操作历史
              } else {
                this.$Message.error(res.message);
              }
            });
          } else if (IsFinish == 3) {
            //console.log(res, "编辑保存诊断意见成功111111111111111111111111");
            this.GetInfo(7);
            (this.diagnosticAdvice = ""), (this.surgicalResuults = "");
            Request.postRequest(AddOperation, {
              PageNum: "4",
              CaseID: this.id,
              Dynamic: `<span>${this.stroge.DocName}</span>修改了诊断意见<em>${this.patientName}</em>`,
              OperationHis: `<span>${this.stroge.DocName}</span>修改了诊断意见`,
              OUserJid: this.stroge.UserJid,
              ODocName: this.stroge.DocName,
              Type: "修改信息",
              OImg: this.stroge.ImgUrl,
              CenterID: this.stroge.CenterID,
            }).then((res) => {
              if (res.code == 200) {
                //console.log("诊断意见操作历史")
                this.GetInfo(3); //操作历史
              } else {
                this.$Message.error(res.message);
              }
            });
          }
        } else {
          this.$Message.error(res.message);
          if (IsFinish == 1) {
            Request.addLog("案例管理", "结束案例", "F", res.message);
          }
        }
      });
    },
    //结束讨论确定按钮
    finishDiscussion() {
      console.log(this.caseType);
      if (!this.caseType) {
        return this.$Message.info("请选择案例类型");
      }
      if (!this.operation) {
        return this.$Message.info("请选择手术名称");
      }
      if (!this.caseCon) {
        return this.$Message.info("请输入案例结论");
      }
      this.EditAndFinishInfo(1);
    },
    //获取参与医生列表
    getPartDoctor() {
      //console.log(this.DocUserJid,11111)
      Request.getRequest(getPartDoctor, {
        UserJid: this.DocUserJid.join(","),
      }).then((res) => {
        //console.log(res, "参与医生列表");
        if (res.code == 200) {
          this.joinDoctor = [];
          res.data.map((item) => {
            this.joinDoctor.push(item);
          });
          // console.log(this.joinDoctor, "参与医生列表");
          this.GetInfo(4);
          let arr = this.PartakeDoc ? JSON.parse(this.PartakeDoc) : "";
          for (let i = 0; i < arr.length; i++) {
            for (let j = 0; j < this.joinDoctor.length; j++) {
              if (arr[i].UserJid == this.joinDoctor[j].UserJid) {
                this.joinDoctor[j].IsFirst = arr[i].IsFirst;
              }
              if (this.joinDoctor[j].UserJid == this.sendPeopleJid) {
                this.joinDoctor[j].IsFirst = "Y";
              }
            }
          }
          this.joinDoctor = _.sortBy(this.joinDoctor, function (item) {
            if (item.IsFirst == "Y") {
              return 1;
            } else if (item.IsFirst == "T") {
              return 2;
            } else {
              return 3;
            }
          });
        //   console.log(this.joinDoctor, "参与医生");
          this.joinDoctor.map((item) => {
            if (item.UserJid == this.stroge.UserJid) {
              this.IsJoin = true;
            }
          });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //参与医生详情
    DoctorDetail(item) {
      this.doctorDetail = true;
      //console.log(item, 12122);
      (this.partDoctorInfo.DocImg = item.ImgUrl),
        (this.partDoctorInfo.DocName = item.DocName),
        (this.partDoctorInfo.DocPosition = item.DocPosition),
        (this.partDoctorInfo.HospitalName = item.HospitalName),
        (this.partDoctorInfo.DepartmentName = item.DepartmentName),
        (this.partDoctorInfo.Position =
          item.Province && item.City ? item.Province + "-" + item.City : ""),
        (this.partDoctorInfo.Intro = item.Introduce),
        (this.partDoctorInfo.GoodAt = item.Skill);
      this.partDoctorInfo.TeamName = item.CenterName;
    },
    //邀请医生确定的接口
    sureGetDoctor() {
      this.doctorShowName = "";
      for (var i = 0; i < this.doctorShow.length; i++) {
        this.doctorShow[i].IsFirst = "F";
        this.doctorShowName += this.doctorShow[i].DocName;
        this.doctorShowUserJid.push(this.doctorShow[i].UserJid);
      }
      this.DocUserJid.push(this.doctorShowUserJid.join(","));
      //console.log(JSON.stringify(this.doctorShowUserJid))
      this.allPartakeDoc = JSON.parse(this.PartakeDoc).concat(this.doctorShow);
      //this.allPartakeDoc = this.doctorShow;
      Request.postRequest(sureGetDoctor, {
        ID: this.id,
        PartakeDoc: JSON.stringify(this.allPartakeDoc),
      }).then((res) => {
        if (res.code == 200) {
          //console.log(res, "邀请医生确定的接口");
          this.getPartDoctor(); //获取参与医生
          this.checkdoctor = [];
          (this.indeterminate = false),
            (this.checkAll = false),
            Request.postRequest(AddOperation, {
              PageNum: "1",
              CaseID: this.id,
              Dynamic: `<span>${this.stroge.DocName}</span>邀请<em>${this.doctorShowName}</em>加入<em>${this.patientName}</em>的案例`,
              OUserJid: this.stroge.UserJid,
              ODocName: this.stroge.DocName,
              ToUser: JSON.stringify(this.doctorShowUserJid),
              Type: "邀请医生",
              OImg: this.stroge.ImgUrl,
              CenterID: this.stroge.CenterID,
            }).then((res) => {
              if (res.code == 200) {
                //console.log("邀请医生操作历史")
                this.GetInfo(3); //操作历史
              } else {
                this.$Message.error(res.message);
              }
            });
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //邀请医生的确定按钮
    inviteDoctor() {
      if (this.doctorShow == "") {
        return this.$Message.error("请选择要邀请的医生");
      }
      this.sureGetDoctor();
    },

    //确定新建诊断意见
    sureOpinion() {
      if (this.diagnosticAdvice == "") {
        return this.$Message.error("请输入诊断意见");
      }
      if (this.surgicalResuults == "") {
        return this.$Message.error("请输入手术结果");
      }
      if (this.diagnoseID == "") {
        this.EditAndFinishInfo(2); //新建诊断意见
      }
      if (this.diagnoseID != "") {
        this.EditAndFinishInfo(3); //修改诊断意见
      }
    },
    //初次新建随访计划
    newFollowPlan() {
      let obj = {
          tablename: "FollowUp",
          ID: '',
          CaseID: this.id,
          IsFollowUp: "否",
          NextFollowUpDate: dayjs(this.followTime).format("YYYY-MM-DD"),
          FollowUpContent: this.followCon,
          UserJid: this.stroge.UserJid,
          DocName: this.stroge.DocName,
        };
       
    //   else {
    //     obj = {
    //       tablename: TNType ? "FollowUp" : "CaseList",
    //       ID: TNType ? "" : this.id,
    //       Status: 3,
    //     };
    //   }
      Request.postRequest(newFollowPlan, obj).then((res) => {
        if ((res.code = 200)) {
          //console.log(res, "新建随访计划");
          this.GetInfo(8); //随访计划
          this.followTime = "";
          this.followCon = "";
            Request.postRequest(AddOperation, {
            PageNum: "6",
            CaseID: this.id,
            FUID: this.FollowPlanId,
            Dynamic: `<span>${this.stroge.DocName}</span>新建<em>${this.patientName}</em>的随访计划`,
            OperationHis: `<span>${this.stroge.DocName}</span>新建随访计划`,
            OUserJid: this.stroge.UserJid,
            ODocName: this.stroge.DocName,
            Type: "新建随访",
            OImg: this.stroge.ImgUrl,
            CenterID: this.stroge.CenterID,
          }).then((res) => {
            if (res.code == 200) {
              //console.log("邀请医生操作历史")
              this.GetInfo(3); //操作历史
            } else {
              this.$Message.error(res.message);
            }
          });
          
          
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //编辑继续随访计划
    //当IsContinueFol = true时是维护随访内容中填随访结果时调的接口
    editFollowPlan(IsContinueFol) {
      let imgStr = [];
      this.professionalList.map((item) => {
        imgStr.push(item.url);
      });
      Request.postRequest(editFollowPlan, {
        tablename: "FollowUp",
        ID: IsContinueFol ? this.FollowPlanId : "",
        CaseID: this.id,
        IsFollowUp: IsContinueFol ? "是" : "否",
        NextFollowUpDate: IsContinueFol
          ? dayjs(this.followNoteTime).format("YYYY-MM-DD")
          : dayjs(this.nextFollowNoteTime).format("YYYY-MM-DD"),
        FollowUpContent: IsContinueFol
          ? this.followNoteCon
          : this.nextFollowCon,
        FUResult: IsContinueFol ? this.followNoteRes : "",
        ImgUrl: IsContinueFol ? JSON.stringify(imgStr) : "",
        Type: IsContinueFol ? 0 : 0,
        UserJid: IsContinueFol ? this.followNoteUserJid : this.stroge.UserJid,
        DocName: IsContinueFol ? this.followNoteDocName : this.stroge.DocName,
      }).then((res) => {
        if (res.code == 200) {
          //console.log(res, "编辑随访计划");
          this.GetInfo(8); //随访计划
          (this.nextFollowNoteTime = ""), (this.nextFollowCon = "");
          this.folType = "";
          if(!IsContinueFol){
              Request.postRequest(AddOperation, {
            PageNum: "6",
            CaseID: this.id,
            FUID: this.FollowPlanId,
            Dynamic: `<span>${this.stroge.DocName}</span>在<em>${this.patientName}</em>的案例补充随访内容并新建随访计划`,
            OperationHis: `<span>${this.stroge.DocName}</span>补充随访内容并新建随访计划`,
            OUserJid: this.stroge.UserJid,
            ODocName: this.stroge.DocName,
            Type: "维护并新建随访",
            OImg: this.stroge.ImgUrl,
            CenterID: this.stroge.CenterID,
          }).then((res) => {
            if (res.code == 200) {
              //console.log("邀请医生操作历史")
              this.GetInfo(3); //操作历史
            } else {
              this.$Message.error(res.message);
            }
          });
          }
          
        }
      });
    },
    //编辑停止随访
    editStopFol() {
      let imgStr = [];
      this.professionalList.map((item) => {
        imgStr.push(item.url);
      });
      Request.postRequest(editFollowPlan, {
        tablename: "FollowUp",
        ID: this.FollowPlanId,
        CaseID: this.id,
        IsFollowUp: "是",
        NextFollowUpDate: dayjs(this.followNoteTime).format("YYYY-MM-DD"),
        FollowUpContent: this.followNoteCon,
        FUResult: this.followNoteRes,
        ImgUrl: JSON.stringify(imgStr),
        Type: 1,
      }).then((res) => {
        if (res.code == 200) {
          //console.log(res, "停止随访计划");
          this.editFolStatus();
          Request.postRequest(AddOperation, {
            PageNum: "6",
            CaseID: this.id,
            FUID: this.FollowPlanId,
            Dynamic: `<span>${this.stroge.DocName}</span>在<em>${this.patientName}</em>的案例补充随访内容`,
            OperationHis: `<span>${this.stroge.DocName}</span>补充随访内容`,
            OUserJid: this.stroge.UserJid,
            ODocName: this.stroge.DocName,
            Type: "维护随访内容",
            OImg: this.stroge.ImgUrl,
            CenterID: this.stroge.CenterID,
          }).then((res) => {
            if (res.code == 200) {
              //console.log("邀请医生操作历史")
              this.GetInfo(3); //操作历史
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      });
    },
    editFolStatus() {
      Request.postRequest(editFollowPlan, {
        tablename: "CaseList",
        ID: this.id,
        Status: 2,
      }).then((res) => {
        //console.log(res, "停止随访");
        this.GetInfo(8); //随访计划
      });
    },
    //点击随访记录
    FolNote(item) {
      //.log(item, 3333333333333333);
      this.folNote = true;
      this.professionalList = [];
      if (item.ImgUrl) {
        JSON.parse(item.ImgUrl).map((ite) => {
          let obj = {
            url: ite,
          };
          this.professionalList.push(obj);
        });
      }
      //console.log(this.professionalList, 2222222222222);

      this.FollowPlanId = item.ID;
      this.followNoteTime = item.NextFollowUpDate;
      this.followNoteCon = item.FollowUpContent;
      this.followNoteRes = item.FUResult;
      this.IsFooter = item.IsFollowUp;
      this.followNoteUserJid = item.UserJid;
      this.followNoteDocName = item.DocName;
    },
    //确定添加随访计划
    addFollow() {
      if (this.followTime == "") {
        return this.$Message.info("请选择随访时间");
      }
      if (this.followCon == "") {
        return this.$Message.info("请添加随访内容");
      }
      this.newFollowPlan();
    //   this.newFollowPlan(false);
      this.follow = false;
      this.$Message.info("添加随访计划成功");
    },
    //确定随访记录
    folNoteSure() {
      if (this.followNoteTime == "") {
        return this.$Message.error("随访时间不能为空");
      }
      if (this.followNoteCon == "") {
        return this.$Message.error("随访内容不能为空");
      }
      if (this.folType == "") {
        return this.$Message.error("请选择随访计划");
      }
      if (this.folType == "继续随访") {
        if (this.nextFollowNoteTime == "") {
          return this.$Message.error("随访时间不能为空");
        }
        if (this.nextFollowCon == "") {
          return this.$Message.error("随访内容不能为空");
        }
        this.editFollowPlan(true);
        this.editFollowPlan(false);
      } else {
        this.editStopFol();
      }
      this.folNote = false;
      //this.$Message.info("确定随访记录");
    },
    //取消随访
    cancelFol() {
      this.folType = "";
    },
    cancel() {
      // this.$Message.info("返回");
    },
    //搜索医生
    searchDoctor() {
      let newarr = _.sortBy(this.doctorList, (item) => {
        if (item.DocName.match(this.searchvalue)) {
          return item.DocName;
        }
      });
      this.doctorList = newarr;
    },
    //全选
    handleCheckAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      if (this.checkAll) {
        let arr = [];
        this.checkdoctorList.map((item) => {
          this.doctorList.map((item1) => {
            if (item1.IsChoose != "T" && item == item1.UserJid) {
              arr.push(item);
            }
          });
        });
        //console.log(arr);
        this.checkdoctor = arr;
        // console.log(this.checkdoctor,this.checkdoctorList,this.doctorShow,1)
      } else {
        this.checkdoctor = [];
        // console.log(this.checkdoctor,this.checkdoctorList,2)
      }
    },
    //多选数据改变的时候
    checkdoctorChange(data) {
      //console.log(data, this.checkdoctorList, "dsdsa");
      if (data.length === this.checkdoctorList.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
    //删除选中的
    handlemodalClose(index) {
      this.checkdoctor.splice(index, 1);
      this.checkAll = false;
      if (this.checkdoctor.length) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },

    /*随访记录上传图片*/
    handleSuccess2(res) {
      if (res.code == 200) {
        //console.log(res, 12121212121);
        this.professionalList.push({ url: res.data[0] });
      }
      this.loading = false;
    },
    handleBeforeUpload2() {
      const check = this.professionalList.length < 4;
      if (!check) {
        this.$Notice.warning({
          title: "最多可以上传四张图片！",
        });
      }
      return check;
    },
    //查看图片
    showprofessionalpicture() {
      this.imgName = this.professionalpicture;
      this.visible = true;
    },
    showprofessional(item) {
      this.imgName = item.url;
      this.visible = true;
    },
    handleRemove2(file) {
      const fileList2 = this.professionalList;
      this.professionalList.splice(fileList2.indexOf(file), 1);
    },
    ok2(file) {
      this.handleRemove2(file);
      this.$Message.info("已删除！");
    },

    cancel2() {},
    handleFormatError(file) {
      this.loading = false;
      this.$Notice.warning({
        title: "文件格式不正确!",
        desc: file.name + "的文件格式不正确，请选择jpg或png",
      });
    },
    //图片上传之前的回调
    beforeUpload() {
      this.loading = true;
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "超过文件大小限制！",
        desc: file.name + "文件太大，不超过2M。",
      });
    },
    /* ------------------------------------- */
    expert() {
      // this.$router.push({
      //   name:'ExpertTeamInformation'
      // });
    },
    //病史删除附件
    delBsInfo(data) {
      this.bsInfoAcc.splice(data, 1);
    },
    //病史上传附件成功
    handleSuccessBs(response, file, fileList) {
      console.log(file);
      if (file.response.code == 200) {
        this.bsInfoAcc.push({ name: file.name, url: file.response.data[0] });
      } else {
        this.$Message.error(file.response.message);
      }
    },
    //病史上传图片成功的回调
    handleSuccess1(res) {
      if (res.code == 200) {
        //console.log(res)
        this.bingshiPic.push(res.data[0]);
      }
      this.loading = false;
      //console.log(this.bingshiPic,121231313)
    },
    DelBs(item) {
      this.DelBsPic = item;
      this.isRemove1 = true;
    },
    // //bs删除
    handleRemove1() {
      const fileList2 = this.bingshiPic;
      this.bingshiPic.splice(fileList2.indexOf(this.DelBsPic), 1);
      // console.log(this.professionalList,'sc')
      // let imgStr = [];
      // this.bingshiPic.map((item)=>{
      //   imgStr = imgStr.concat(item.url)
      //   this.bingshiPic1 = JSON.stringify(imgStr)
      // })
    },

    //临床资料上传图片成功的回调
    handleSuccess3(res) {
      if (res.code == 200) {
        //console.log(res)
        this.lcpic.push(res.data[0]);
      }
      this.loading = false;
    },
    //lc删除
    DelLc(item) {
      this.DelLcPic = item;
      this.isRemove3 = true;
    },
    handleRemove3() {
      const fileList3 = this.lcpic;
      this.lcpic.splice(fileList3.indexOf(this.DelLcPic), 1);
      // let Str = [];
      // this.lcpic.map((item)=>{
      //   //console.log(item.url)
      //   Str = Str.concat(item.url)
      //   this.lcInfoPic1 = JSON.stringify(Str)
      // })
    },
  },
  created() {
    this.$emit("funChangeTitle", "案例详情", "2-2");
    this.tabName = this.$route.params.tabName;
    //console.log(this.stroge,1111111111111)
  },
  mounted() {
    this.lcInfoAcc = this.$refs.UploadAcc.fileList;
    this.bsInfoAcc = this.$refs.UploadBsAcc.fileList;
    this.bsInfoAcc = [];
    this.lcInfoAcc = [];
    this.professionalList = this.$refs.upload2.fileList;
    this.bingshiPic = this.$refs.upload1.fileList;
    //.log(this.bingshiPic)
    this.lcpic = this.$refs.upload3.fileList;
    this.GetInfo(1); //个人信息
    this.getPartDoctor(); //获取参与医生
    this.GetInfo(2); //手术名称
    this.GetInfo(3); //操作历史
    this.GetInfo(4); //邀请医生
    this.GetInfo(8);
    this.GetInfo(5); //病史
    this.GetInfo(7); //诊断意见
    this.GetCaseClinical("全部");
  },
};
</script>

<style lang="less">
.caseDetail {
  .header {
    .ivu-tabs-bar {
      margin-bottom: 0;
      padding: 16px 16px 0 16px;
    }
    //总览信息
    .content {
      // margin: 0 0 0 24px;
      background: #f3f5f7;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      .left {
        padding-top: 20px;
        padding-left: 64px;
        display: flex;
        width: 54%;
        height: 1013px;
        background: white;
        .baseInfo {
          //margin-top: 16px;
          margin-bottom: 24px;
          width: 400px;
          display: flex;
          flex-direction: column;
          .box {
            margin-top: 24px;
            .ivu-input-number-input::-webkit-outer-spin-button,
            .ivu-input::-webkit-inner-spin-button {
              -webkit-appearance: none;
            }
            // .ivu-input-number-input[type="number"] {
            //   -moz-appearance: textfield;
            // }
          }
          .btnBottom {
            display: flex;
            justify-content: space-between;
          }
          .ivu-input-number-input {
            color: #5f6368;
          }
          .ivu-input-disabled {
            color: #5f6368;
          }
          .ivu-select-selected-value {
            color: #5f6368;
          }
        }
      }
      .right {
        width: 44%;
        height: 1013px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        //align-items: ;
        align-content: space-between;

        //操作历史
        .operation {
          padding: 16px 16px 0;
          width: 100%;
          height: 460px;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          background: white;
          overflow-y: auto;
          .hint {
            text-align: center;
            line-height: 300px;
            color: gainsboro;
          }
          .trends {
            height: 100%;
            margin-top: 15px;
            background: white;
            border-radius: 0;
            .doctorInfo {
              width: 400px;
              height: 55px;
              display: flex;
              align-items: center;
              .introduce {
                height: 60px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin-left: 30px;
                .greet {
                  font-size: 15px;
                  font-weight: 800;
                  color: black;
                  span {
                    margin-right: 5px;
                  }
                  em {
                    font-style: normal;
                    color: rgb(25, 111, 223);
                  }
                }
                .time {
                  margin-top: 3px;
                  font-size: 13px;
                  color: rgb(151, 144, 144);
                }
              }
            }
          }
        }
        .doctor {
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          padding: 16px 16px;
          width: 100%;
          height: 520px;
          overflow-y: auto;
          background: white;
          .docHead {
            display: flex;
            justify-content: space-between;
            padding-right: 16px;
          }
          .docCard {
            width: 500px;
            height: 130px;
            margin: 20px 16px;
            padding-left: 48px;
            cursor: pointer;
            // background: linear-gradient(#188EE7, #036ACF);
            border-radius: 5px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              position: absolute;
              top: 20px;
              left: -24px;
            }
            .docContent {
              width: 500px;
              height: 100px;
              //background: red;
              div {
                margin-bottom: 20px;
              }
              .box1 {
                margin-top: 10px;
                span {
                  font-weight: 800;
                }
              }
              .box2 {
                span {
                  font-size: 18px;
                }
              }
              span {
                color: white;
                font-size: 20px;
                margin-right: 48px;
              }
              .biaoqian {
                font-size: 16px;
                position: absolute;
                right: -48px;
                width: 80px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                background: orange;
                border-radius: 15px 0 0 15px;
              }
              .biaoqian1 {
                font-size: 16px;
                position: absolute;
                right: -48px;
                width: 80px;
                height: 30px;
                text-align: center;
                line-height: 30px;
                background: skyblue;
                border-radius: 15px 0 0 15px;
              }
            }
          }
          .docCard:nth-of-type(even) {
            background: linear-gradient(#188ee7, #036acf);
          }
          .docCard:nth-of-type(odd) {
            background: linear-gradient(#5ec8c8, #0c9f9f);
          }
        }
      }
    }
    //病史
    .medicalHistory {
      .ivu-input-disabled {
        color: #5f6368;
      }
      .picBox {
        display: flex;
        justify-content: flex-start;
        .up {
          margin-right: 20px;
        }
        .professionalimg {
          .viewer {
            display: flex;
            flex-wrap: wrap;
            .Photo {
              position: relative;
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 12px;
              .ivu-icon-md-close {
                top: 0;
                right: 12px;
              }
              img {
                width: 100px;
                height: 100px;
                margin-right: 12px;
              }
            }
          }
        }
      }
      .accBox {
        .accCon {
          border-radius: 8px;
          height: 50px;
          padding: 0 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #f3f3f3;
          margin-top: 6px;
          width: 90%;
          span {
            font-size: 16px;
          }
        }
      }
      .bsBottom {
        width: 100%;
        display: flex;
        justify-content: center;
        position: fixed;
        bottom: 50px;
      }
    }
    //临床资料
    .clinicalData {
      height: 100%;
      display: flex;
      justify-content: space-between;
      .lcLeft {
        .ivu-menu-vertical .ivu-menu-item {
          display: flex;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            margin-right: 12px;
          }
        }
      }
      .lcRight {
        height: 790px;
        overflow-y: auto;
        padding: 0 24px;
        padding-top: 24px;
        flex: 1;
        .recordList {
          cursor: pointer;
          margin-top: 24px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          border-bottom: 1px #e6e6e6 solid;
          padding-bottom: 12px;
          .box1 {
            display: flex;
            align-items: center;
            div {
              width: 66px;
              height: 66px;
              text-align: center;
              line-height: 66px;

              color: white;
            }
            img {
              width: 30px;
              height: 30px;
              margin-left: 12px;
            }
          }
          .recordCon {
            margin: 0 12px;
          }
        }
      }
    }
    //诊断及讨论
    .disCon {
      //margin: 0 0 0 24px;
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      .left {
        width: 40%;
        height: 790px;
        overflow-y: auto;
        border-right: 1px solid #e9e9e9;
        padding: 20px 00px 20px 0px;
        .Lhead {
          padding: 0 20px 0 40px;
          display: flex;
          justify-content: space-between;
        }
        .opinionCon {
          cursor: pointer;
          //background: chartreuse;
          width: 100%;
          margin-top: 20px;
          padding-left: 80px;
          position: relative;
          display: inline-block;
          border-bottom: 1px solid #e6e6e6;
          span {
            font-size: 14px;
            margin-right: 24px;
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            position: absolute;
            top: 8px;
            left: 18px;
          }
          .docContent {
            width: 500px;
            //height: 100px;

            div {
              margin-bottom: 5px;
            }
            .box1 {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .Rbox1 {
                color: #c1c1c1;
              }
              span:first-child {
                font-weight: 800;
                font-size: 16px;
              }
            }
            // .box2{
            //   span{

            //   }
            // }
          }
        }
      }
      //讨论列表
      .right {
        width: 60%;
        height: 790px;
        padding: 20px 0px 20px 0px;
        .Rhead {
          padding-left: 10px;
          display: flex;
          justify-content: space-between;
          //border-bottom: 1px solid #e9e9e9;
          padding-bottom: 12px;
        }
        .dicList {
          width: 100%;
          height: 98%;
        }
      }
    }
    //案例结果
    .caseRes {
      height: 490px;
      //height: 100%;
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .caseResBtn {
        margin-top: 24px;
      }
    }
    //随访
    .follow {
      display: flex;
      flex-direction: column;
      padding: 20px 20px;
      .folHead {
        width: 100%;
        display: flex;
        justify-content: space-between;
      }
      .folCon {
        margin-top: 24px;
        .time {
          display: flex;
          width: 200px;
          justify-content: space-between;
          p:first-child {
            font-size: 16px;
            font-weight: bold;
          }
          .tag {
            width: 60px;
            height: 20px;
            font-size: 14px;
            color: white;
            background: #5ac47a;
            border-radius: 10px 10px;
            text-align: center;
            line-height: 20px;
          }
          .tag1 {
            background: #28d094;
          }
          .tag2 {
            background: #1890ff;
          }
        }
        .content {
          display: block;
          width: auto;
          font-size: 18px;
          color: #c1c1c1;
          background: white;
          padding-left: -25px;
        }
      }
    }
  }
}
//总览信息的弹窗
//邀请医生弹窗
.modalmod {
  .ivu-modal {
    width: 700px !important;
  }
}
.modalmain {
  height: 480px;
  .ivu-col {
    padding: 0 15px;
    height: 100%;
    overflow: auto;
    .doctorlist {
      margin: 10px 0;
      .ivu-checkbox-wrapper {
        display: block;
        line-height: 30px;
        margin: 10px 0;
        .ivu-checkbox {
          margin-right: 7px;
        }
        img {
          width: 30px;
          height: 30px;
          vertical-align: middle;
          border-radius: 50%;
        }
      }
    }
    .ivu-tag {
      height: auto;
    }
  }
}
.modalmain::before {
  content: "";
  position: absolute;
  left: 50%;
  width: 1px;
  top: 0;
  height: 100%;
  bottom: 0;
  background: #e4e4e4;
}
//医生详细信息的弹窗
.doctorDetail {
  .ivu-modal-body {
    .mod {
      //background: pink;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .img1 {
        width: 100px;
        height: 100px;
        margin-top: 24px;
        border-radius: 50%;
      }
      > div {
        margin-top: 24px;
      }
      div:nth-of-type(1) {
        span {
          font-size: 20px;
          font-weight: 900;
          margin-right: 14px;
        }
      }
      div:nth-of-type(2) {
        span {
          margin-right: 16px;
        }
      }
      div:nth-of-type(3) {
        width: 300px;
      }
      div:nth-of-type(4),
      div:nth-of-type(5) {
        width: 300px;
        div {
          border-radius: 5px;
          background: #f5f5f5;
          text-indent: 24px;
          overflow-y: auto;
        }
      }
      .BotTeam {
        margin-top: 40px;
        position: relative;
        display: flex;
        width: 460px;
        justify-content: space-around;
        align-items: center;
        span {
          position: absolute;
        }
      }
    }
  }
}
//诊断及讨论的弹窗
.newOpinion {
  .ivu-modal-body {
    .mod {
      //background: pink;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .img1 {
        width: 100px;
        height: 100px;
        margin-top: 24px;
        border-radius: 50%;
      }
      > div {
        margin-top: 24px;
      }
      div:nth-of-type(1) {
        span {
          font-size: 20px;
          font-weight: 900;
          margin-right: 14px;
        }
      }
      div:nth-of-type(2) {
        width: 300px;
        text-align: center;
        padding-bottom: 16px;
        border-bottom: 1px dashed #c1c1c1;
        span {
          margin-right: 16px;
        }
      }
    }
  }
}
//维护随访内容
.folNote {
  .ivu-form-item-label {
    float: none;
  }
  .ivu-form-item-content {
    display: flex;
    justify-content: space-around;
  }
  .professionalimg {
    display: inline-block;
    width: 104px;
    height: 104px;
    text-align: center;
    line-height: 104px;
    border: 1px solid transparent;
    border-radius: 4px;
    background: #fff;
    margin-left: 10px;
    border: 1px solid rgba(216, 216, 216, 1);
    img {
      width: 96px;
      height: 51px;
    }
    .imgbot1 {
      cursor: pointer;
      position: absolute;
      left: 20px;
      bottom: -30px;
    }
    .ivu-poptip-popper {
      top: -120px !important;
      left: 30px !important;
    }
    .ivu-poptip-confirm .ivu-poptip-body .ivu-icon {
      position: relative !important;
    }
  }
}
//添加资料
.addData {
  .picBox {
    display: flex;
    justify-content: flex-start;
    .up {
      margin-right: 20px;
    }
    .professionalimg {
      .viewer {
        display: flex;
        flex-wrap: wrap;
        .Photo {
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
          .ivu-icon-md-close {
            top: 0;
            right: 12px;
          }
          img {
            width: 100px;
            height: 100px;
            margin-right: 12px;
          }
        }
      }
    }
  }
  .accBox {
    .accCon {
      border-radius: 8px;
      height: 40px;
      padding: 0 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #f3f3f3;
      margin-top: 6px;
      width: 90%;
      span {
        font-size: 16px;
      }
    }
  }
  .dicom{
      width: 100%;
      display: flex;
      justify-content: space-between;
      position: relative;
    //   #1890FF
      .border1{
          width: 120px;
          border-top: 1px solid #ccc;
          position: absolute;
          left: 294px;
          top: 15px;
      }
      .border2{
          width: 120px;
          border-top: 1px solid #ccc;
          position: absolute;
          right: 108px;
          top: 15px;
      }
  }
  .ivu-input-disabled {
    color: #5f6368;
  }
  .ivu-select-selected-value {
    color: #5f6368;
  }
}
</style>